var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-card-header',[_vm._v("Sign Out")]),_c('b-card-body',[_vm._v(" See you again soon! "),_c('br'),_c('br'),_c('i',{staticClass:"fa fa-hand-paper-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Bye. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }